// Copyright (C) 2017-2022 Smart code 203358507

const KeyboardShortcuts = require('./KeyboardShortcuts');

module.exports = KeyboardShortcuts;
